<template>

    <div class="bonus-item" v-if="today_id == bonus.id">
        <div class="bonus-item-content to-day">
            <div class="title">{{ $t('to_day_uppercase') }}</div>
            <div class="thumb ratio110x228">
                <div class="thumb-content">
                    <div class="bonus-item-body active current">
                        <!--<div class="row1">{{ $t('day_uppercase') }} {{ bonus.id }}</div>-->
                        <div class="row1">{{ $t(bonus.desc) }}</div>
                        <div class="row2">
                            <AppIcon :src="$store.state.gem_icon_url" :width="45" :height="52" style="line-height: 52px; margin: 20px auto 10px auto;" />
                        </div>
                        <div class="row3">+{{ bonus.gem }}</div>
                    </div>
                    <i class="ito-icon-checked-1" v-if="bonus.status == 2 || (bonus.status == 1 && user_info.first_login == 0)"></i>
                </div>
            </div>
            <div class="bonus-item-bottom">
                <button class="btn btn-ito-4" v-if="bonus.status == 1 && user_info.first_login == 1" @click="claim">
                    {{ $t('claim') }}
                </button>
            </div>
        </div>
    </div>
    <div class="bonus-item" v-else-if="bonus.status == 2">
        <div class="bonus-item-content">
            <div class="title">&nbsp;</div>
            <div class="thumb ratio110x210">
                <div class="thumb-content">
                    <div class="bonus-item-body">
                        <!--<div class="row1">{{ $t('day_uppercase') }} {{ bonus.id }}</div>-->
                        <div class="row1">{{ $t(bonus.desc) }}</div>
                        <div class="row2">
                            <AppIcon :src="$store.state.gem_icon_url" :width="45" :height="52" style="line-height: 52px; margin: 20px auto 10px auto;" />
                        </div>
                        <div class="row3">+{{ bonus.gem }}</div>
                    </div>
                    <i class="ito-icon-checked-1"></i>
                </div>
            </div>
            <div class="bonus-item-bottom">

            </div>
        </div>
    </div>
    <div class="bonus-item" v-else-if="bonus.status == 1">
        <div class="bonus-item-content to-day">
            <div class="title">{{ $t('to_day_uppercase') }}</div>
            <div class="thumb ratio110x228">
                <div class="thumb-content">
                    <div class="bonus-item-body active current">
                        <div class="row1">{{ $t('day_uppercase') }} {{ bonus.id }}</div>
                        <div class="row2">
                            <AppIcon :src="$store.state.gem_icon_url" :width="45" :height="52" style="line-height: 52px; margin: 20px auto 10px auto;" />
                        </div>
                        <div class="row3">+{{ bonus.gem }}</div>
                    </div>
                </div>
            </div>
            <div class="bonus-item-bottom">
                <button class="btn btn-ito-4" data-bs-toggle="modal" data-bs-target="#getRewardedModal">
                    {{ $t('claim') }}
                </button>
            </div>
        </div>
    </div>
    <div class="bonus-item" v-else>
        <div class="bonus-item-content">
            <div class="title">&nbsp;</div>
            <div class="thumb ratio110x210">
                <div class="thumb-content">
                    <div :class="bonus.desc == 'day_7' ? 'bonus-item-body active-1' : 'bonus-item-body active'">
                        <!--<div class="row1">{{ $t('day_uppercase') }} {{ bonus.id }}</div>-->
                        <div class="row1">{{ $t(bonus.desc) }}</div>
                        <div class="row2">
                            <AppIcon :src="$store.state.gem_icon_url" :width="45" :height="52" style="line-height: 52px; margin: 20px auto 10px auto;" />
                        </div>
                        <div class="row3">+{{ bonus.gem }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapGetters } from 'vuex';
import { claimDailyBonus } from "../../models/reward";
import AppIcon from '@/components/common/AppIcon.vue';
export default {
    name: "DailyBonusItem",
    components: { AppIcon },
    props: ['bonus', 'today_id'],

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return {
                gem: 0
            }
        })
    },

    data() {
        return {};
    },

    created() {

    },

    methods: {
        claim() {
            const that = this;

            claimDailyBonus().then((response) => {
                console.log(response);

                if (response.data.code != 0) {
                    return;
                }

                that.bonus.status = response.data.results.status || '';

                that.user_info.dailychallenge_noti = response.data.results.dailychallenge_noti || 0;

                const new_gem = response.data.results.update_gem || 0;
                const gem = new_gem - that.user_info.gem;

                that.user_info.gem = new_gem;

                const gem_txt = gem > 0 ? '+' + gem : gem;

                this.$emit('updateBonus', response.data.results);

                $('#congratulation_gem').text(gem_txt);
                $('#getRewardedModal').modal('show');
                //location.reload();
            }).catch(({ response }) => {
                console.error(response);
            });
        },

    }
}
</script>

<style scoped></style>